export default "__VITE_ASSET__B_5Di7z6__"